import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

/**
 * Lightning bolt — used as the announcement / system-notification
 * glyph (amber treatment). Matches the prototype's `IC.bolt` path
 * (`app/icons.js`).
 */
const Bolt = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, className, onClick }, ref) => {
    return (
      <svg
        ref={ref}
        width={size ?? 24}
        height={size ?? 24}
        viewBox="0 0 24 24"
        fill={color}
        className={className}
        onClick={onClick}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M13 2 4 14h7l-1 8 9-12h-7z" />
      </svg>
    );
  },
);

export default Bolt;
